<template>
<v-card outlined class="saved-search__list-item">
  <v-card-actions class="justify-end">
    <v-btn @click="edit" icon :title="$t('Bearbeiten')"><v-icon>$vuetify.icons.edit</v-icon></v-btn>
    <v-btn @click="remove" icon :title="$t('Löschen')"><v-icon>$vuetify.icons.clear</v-icon></v-btn>
  </v-card-actions>
  <v-list-item three-line>
    <v-list-item-content>
      <div class="text-overline">{{ objectType }}<span v-if="!item.active">, inaktiv</span></div>
      <v-list-item-title class="text-h3">{{ title }}</v-list-item-title>
      <p v-if="objectLocationTitle">
        <v-icon color="primary">$vuetify.icons.mapMarkerAlt</v-icon>
        <span v-html="objectLocationTitle"></span>
      </p>
      <p v-if="objectPriceTitle">
        <v-icon color="primary">$vuetify.icons.coins</v-icon>
        <span v-html="objectPriceTitle"></span>
      </p>
    </v-list-item-content>
  </v-list-item>
</v-card>
</template>

<script>
export default {
  name: "SavedSearch",

  components: {
  },

  props: [
    "categoryList",
    "item"
  ],

  computed: {
    title() {
      if (this.item.category && this.item.marketingType) {
        return this.$t("categoryMarketingType_" + this.item.marketingType, { category: this.$t(this.item.category.name) });
      }

      if (this.item.category) {
        return this.item.category.name;
      }

      return this.$t("marketingType_" + this.item.marketingType);
    },

    objectType() {
      if (this.item.objectType == "COMMERCIAL") {
        return this.$t("Gewerbe");
      }

      return this.$t("Wohnen");
    },

    objectPriceTitle() {
      let price;
      this.item.fields.forEach((field) => {
        if (field.name == "price.price") {
          price = field;
        }
      });

      let subtitle = null;
      if (price) {
        if (price.minValue && price.maxValue) {
          subtitle = this.$n(price.minValue, "currency") + " &ndash; " + this.$n(price.maxValue, "currency");
        } else if (price.maxValue) {
          subtitle = this.$t("max.") + " " + this.$n(price.maxValue, "currency");
        } else if (price.minValue) {
          subtitle = this.$t("min.") + " " + this.$n(price.minValue, "currency");
        }
      }

      return subtitle;
    },

    objectLocationTitle() {
      let subtitle = "";
      let locations = [];
      this.item.locations.forEach((location) => {
        if (locations.length < 3) {
          locations.push(location.name);
        }
      });

      if (locations.length > 0) {
        subtitle = locations.join(", ");
      }

      if (this.item.locations.length > locations.length) {
        subtitle += (" +" + (this.item.locations.length - 3));
      }

      return subtitle;
    }
  },

  methods: {
    edit() {
      this.$emit("edit", this.item);
    },

    remove() {
      this.$emit("remove", this.item);
    }
  }
};
</script>
